import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { useIntl } from '@/intl'
import styles from './EmptyTableMessage.module.css'

export function EmptyTableMessage() {
  const intl = useIntl()

  return (
    <div className={styles.emptyMessage}>
      <Dialog
        type="custom"
        icon="FaceSad"
        text={intl.formatMessage({ id: 'groups_responsible__no_data_title' })}
        supportingText={intl.formatMessage({ id: 'groups_responsible__no_data_description' })}
      />
    </div>
  )
}
